/*eslint-disable */
// 实现自定义格式
class CustomFormatter {
  prev;
  next;
  _caches;

  constructor(options = {}) {
    this._caches = {};
    this.prev = options.prev || '[';
    this.next = options.next || ']';
  }

  //
  // 插值
  //
  // @param {string} 信息
  //   列表或具名格式的字符串。
  //   例如：
  //   - 具名格式：'Hi {name}'
  //   - 列表格式：'Hi {0}'
  //
  // @param {Object | Array} 值
  //   `message` 插值的值
  //   使用 `$t`， `$tc` 和 `i18n` 函数式组件传递值。
  //   e.g.
  //   - $t('hello', { name: 'kazupon' }) -> 传递值：Object `{ name: 'kazupon' }`
  //   - $t('hello', ['kazupon']) -> 传递值：Array `['kazupon']`
  //   - `i18n` 函数式组件 (组件插值)
  //     <i18n path="hello">
  //       <p>kazupon</p>
  //       <p>how are you?</p>
  //     </i18n>
  //     -> 传递值：Array (included VNode):
  //        `[VNode{ tag: 'p', text: 'kazupon', ...}, VNode{ tag: 'p', text: 'how are you?', ...}]`
  //
  // @return {Array<any>}
  //   插值，你需要返回以下内容：
  //   - 当使用 `$t` 或 `$tc` 数组中应该是字符串。
  //   - 当使用 `i18n` 函数式组件时 数组中应包含 VNode 对象。
  //
  interpolate(message, values) {
    if (!values || JSON.stringify(values) === '{}') {
      return [message];
    }
    let tokens = this._caches[message];
    if (!tokens) {
      tokens = parse(message, this.prev, this.next);
      this._caches[message] = tokens;
    }
    return compile(tokens, values);
  }
}

const RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
const RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}

function warn(msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function parse(format, prev = '{', next = '}') {
  const tokens = [];
  let position = 0;

  let text = '';
  while (position < format.length) {
    let char = format[position++];
    if (char === prev) {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      let sub = '';
      char = format[position++];
      while (char !== undefined && char !== next) {
        sub = `${sub}${char}`;
        char = format[position++];
      }
      const isClosed = char === next;

      const type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
        ? 'named'
        : 'unknown';
      tokens.push({ value: sub, type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[position] !== prev) {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens;
}

function compile(tokens, values) {
  const compiled = [];
  let index = 0;

  const mode = Array.isArray(values)
    ? 'list'
    : isObject(values)
    ? 'named'
    : 'unknown';
  if (mode === 'unknown') {
    return compiled;
  }

  while (index < tokens.length) {
    const token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break;
      case 'list':
        compiled.push(values[token.value]);
        break;
      case 'named':
        if (mode === 'named') {
          compiled.push(values[token.value]);
        } else {
          if (process.env.NODE_ENV !== 'production') {
            warn(
              `Type of token '${token.type}' and format of value '${mode}' don't match!`
            );
          }
        }
        break;
      case 'unknown':
        if (process.env.NODE_ENV !== 'production') {
          warn(`Detect 'unknown' type of token!`);
        }
        break;
    }
    index++;
  }

  return compiled;
}

export default CustomFormatter;
